export default __webpack_public_path__ + "static/elevation_bg-2b15dd53033f23935cee100181e3bb5c.png";